import axios from 'axios';
import i18n from '@/i18n';
import types from '../../types';
/* eslint-disable */
export default {
  // PICKUP
  [types.GET_BOOKED_SINGLE_PICKUP]: async (context, payload) => {
    try {
      return await axios.get(`booked-pickup/${payload}/get`).then((res) => {
        context.commit(types.STORE_SINGLE_PICKUP, res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_NOT_PLANNED_SINGLE_PICKUP]: async (context, payload) => {
    try {
      return await axios.get(`not-planned-pickup/${payload}/get`).then((res) => {
        context.commit(types.STORE_SINGLE_PICKUP, res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.CLEAR_SINGLE_PICKUP]: async (context) => {
    context.commit(types.CLEAR_SINGLE_PICKUP);
  },
  [types.GET_BOOKED_PICKUP_SHIPMENTS]: async (context, payload) => {
    try {
      return await axios.get(`/pickup-actions/${payload.id}/get-booked-shipments`).then((res) => {
        context.commit(types.STORE_PICKUP_SHIPMENTS, res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_NOT_PLANNED_PICKUP_SHIPMENTS]: async (context, payload) => {
    try {
      return await axios.get(`/pickup-actions/${payload.id}/get-not-planned-shipments`).then((res) => {
        context.commit(types.STORE_PICKUP_SHIPMENTS, res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.CLEAR_BOOKED_PICKUP_SHIPMENTS]: async (context) => {
    context.commit(types.CLEAR_BOOKED_PICKUP_SHIPMENTS)
  },
  [types.CLEAR_NOT_PLANNED_PICKUP_SHIPMENTS]: async (context) => {
    context.commit(types.CLEAR_NOT_PLANNED_PICKUP_SHIPMENTS)
  },
  [types.GET_BOOKED_PICKUPS]: async (context, payload) => {
    try {
      await axios.get(`booked-pickup/get-list?page=${payload.page}${payload.query}`).then((res) => {
        if(payload.page == 1){
          context.commit(types.RESET_BOOKED_PICKUPS, res.data.data);
        } else {
          context.commit(types.STORE_BOOKED_PICKUPS, res.data.data);
        }
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.STORE_BOOKED_PICKUPS]: ({commit}, payload) => {
    commit(types.STORE_BOOKED_PICKUPS, payload);
  },
  [types.CLEAR_BOOKED_PICKUPS]: (context) => {
    context.commit(types.CLEAR_BOOKED_PICKUPS);
  },
  // NOT PLANNED PICKUP
  [types.GET_NOT_PLANNED_PICKUPS]: async (context, payload) => {
    try {
      await axios.get(`not-planned-pickup/get-list?page=${payload.page}${payload.query}`).then((res) => {
        if(payload.page == 1){
          context.commit(types.RESET_NOT_PLANNED_PICKUPS, res.data.data);
        } else {
          context.commit(types.STORE_NOT_PLANNED_PICKUPS, res.data.data);
        }
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.STORE_NOT_PLANNED_PICKUPS]: ({commit}, payload) => {
    commit(types.STORE_NOT_PLANNED_PICKUPS, payload);
  },
  [types.CLEAR_NOT_PLANNED_PICKUPS]: (context) => {
    context.commit(types.CLEAR_NOT_PLANNED_PICKUPS);
  },
  [types.GET_PICKUP_LOCATIONS]: async (context) => {
    try {
      return await axios.get('utilities/get-pickup-locations').then((res) => {
        context.commit('STORE_PICKUP_LOCATIONS', res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_PICKUP_ALLOWED_FREIGHT_PRODUCTS]: async (context) => {
    try {
      return await axios.get('utilities/get-pickup-allowed-freight-products').then((res) => {
        context.commit(types.STORE_PICKUP_ALLOWED_FREIGHT_PRODUCTS, res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_AVAILABLE_PICKUP_PRODUCTS]: async (context, payload) => {
    try {
      return await axios.post('rate/get-pickup', payload).then((res) => {
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_PICKUP_PRODUCT]: async (context, payload) => {
    try {
      return await axios.get(`pickup-actions/${payload}/get-pickup-product`).then((res) => {
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.BOOK_PICKUP]: async (context, payload) => {
    try {
      return await axios.post('booked-pickup/create', payload).then((res) => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('pickup_successfully_booked'),
          type: 'success-window',
          iconName: 'check',
        });
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.UPDATE_PICKUP_ADDRESS]: async (context, payload) => {
    try {
      return await axios.post(`pickup-actions/${payload.id}/update-address`, payload.data).then((res) => {
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.DOWNLOAD_PICKUP_EOD]: async (context, payload) => {
    try {
      return await axios.get(`/pickup-actions/${payload}/download-pdf`, {responseType: 'blob'}).then((res) => {
        return res.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.DOWNLOAD_PICKUP_POD]: async (context, payload) => {
    try {
      return await axios.get(`/pickup-actions/${payload}/download-pod`, {responseType: 'blob'}).then((res) => {
        return res.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.EDIT_BOOKED_PICKUP]: async (context, payload) => {
    try {
      return await axios.put(`/pickup-actions/${payload.id}/edit-booked-pickup`, payload).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('booked_pickup_edited_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.CANCEL_PICKUP]: async (context, payload) => {
    try {
      return await axios.put(`/pickup-actions/${payload.id}/cancel`).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('pickup_canceled_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_EMPTY_PICKUPS_BY_SHIPMENT]: async (context, payload) => {
    try {
      return await axios.put(`/pickup-actions/get-empty-pickups?shipment_ids=[${payload}]`);
    } catch (err) {
      console.error(err);
    }
  },
  [types.MOVE_SHIPMENTS_FROM_BOOKED_TO_NOT_PLANNED_PICKUP]: async (context, payload) => {
    try {
      return await axios.put(`/pickup-actions/${payload.id}/move-shipments-from-booked-to-not-planned?shipment_ids=[${payload.shipmentIds}]`).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('shipment_successfully_moved_to_not_planned_pickup'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.REMOVE_SHIPMENTS_FROM_NOT_PLANNED_PICKUP]: async (context, payload) => {
    try {
      return await axios.put(`/pickup-actions/${payload.id}/remove-shipments-from-not-planned?shipment_ids=[${payload.shipmentIds}]`).then((res) => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('shipment_successfully_removed_from_not_planned_pickup'),
          type: 'success-window',
          iconName: 'check',
        });
        return res;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_AVAILABLE_BOOKED_PICKUPS]: async (context, payload) => {
    try {
      const data = payload.data ? payload.data : {};
      const pickupId  = payload.id ? `/${payload.id}` : ''
      return await axios.put(`/pickup-actions${pickupId}/get-available-booked-pickups?pickup_date=${payload.pickupDate}&shipment_ids=[${payload.shipmentIds}]`, data).then((res) => {
        //context.commit(types.STORE_PICKUP_ALLOWED_FREIGHT_PRODUCTS, res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.MOVE_SHIPMENTS_TO_BOOKED_PICKUP]: async (context, payload) => {
    try {
      const moveFromPickupId = payload.moveFromPickupId ? `/${payload.moveFromPickupId}` : '';
      return await axios.put(`/pickup-actions${moveFromPickupId}/move-shipments-to-booked-pickup?move_to_pickup_id=${payload.moveToPickupId}&shipment_ids=[${payload.shipmentIds}]`).then((res) => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('shipment_successfully_removed_from_not_planned_pickup'),
          type: 'success-window',
          iconName: 'check',
        });
        return res;
      });
    } catch (err) {
      console.error(err);
    }
  },
};
